import { makeVar } from '@apollo/client'

import { localStorageKeys } from '@src/constants/localStorageKeys'

export const jwtVar = makeVar<string | null>(
  localStorage.getItem(localStorageKeys.jwt)
)
